import ButtonPrimary from 'components/ButtonPrimary'
import ContentBox from 'components/ContentBox'
import Flex from 'components/Flex'
import { View } from 'components/View'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import openAppSignInModalAction from 'modules/modal/actions/open-app-sign-in'
import React from 'react'
import { defineMessages } from 'react-intl'
import useDispatch from 'modules/component/utils/hooks/useDispatch'
import useIntl from 'modules/component/utils/hooks/useIntl'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import { getSelectedSubscriptionPlanSelect } from 'modules/training/modules/training-premium/selectors/get-selected-subscription-plan/index.js'
import { isPremiumPlusSubscriptionUserUtil } from 'models/daos/user/utils/is-premium-plus-subscription/index.js'
import { logEventAnalyticsUtil } from 'modules/analytics/utils/log-event/index.js'

import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen/index.js'

const messages = defineMessages({
  logIn: {
    id: 'AppLogin.logIn',
    defaultMessage: 'Log in'
  },
  loginToTryPremium: {
    id: 'AppLogin.loginToTryPremium',
    defaultMessage: 'Log in to Start Your Free trial ⭐️'
  },
  loginToTryPremiumPlus: {
    id: 'AppLogin.loginToTryPremiumPlus',
    defaultMessage: 'Log in to Start Your Free trial 💎'
  },
  login: {
    id: 'AppLogin.login',
    defaultMessage: 'Log in'
  }
})

const ANALYTIC_EVENT = {
  APP_LOGIN_PRESSED: 'APP_LOGIN_PRESSED'
}

/**
 * @param isPremiumPage
 * @returns {JSX.Element}
 * @constructor
 */
export function AppLogin ({ isPremiumPage }) {
  const intl = useIntl()
  const dispatch = useDispatch()
  const selectedSubscriptionPlan = useSelector(getSelectedSubscriptionPlanSelect)
  const isPremiumPlus = isPremiumPlusSubscriptionUserUtil(selectedSubscriptionPlan)
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)

  let message
  if (isPremiumPage && isPremiumPlus) {
    message = messages.loginToTryPremiumPlus
  } else if (isPremiumPage && !isPremiumPlus) {
    message = messages.loginToTryPremium
  } else {
    message = messages.login
  }

  const handlePress = () => {
    logEventAnalyticsUtil(ANALYTIC_EVENT.APP_LOGIN_PRESSED)
    dispatch(openAppSignInModalAction())
  }

  return (
    <Flex
      mW='100vw'
    >
      <ContentBox
        ac
        style={{
          minWidth: isSmallScreen ? null : '22em'
        }}
      >
        <View pb>
          <h3 style={{
            whiteSpace: 'pre',
            textAlign: 'center'
          }}
          >
            {formatMessageIntlUtil(intl, message)}
          </h3>
        </View>

        <ButtonPrimary
          onClick={handlePress}
        >
          {formatMessageIntlUtil(intl, messages.logIn)}
        </ButtonPrimary>
      </ContentBox>
    </Flex>
  )
}
